import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./employeeavailability.css";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import moment from "moment";
import FreeBreakfastOutlinedIcon from '@mui/icons-material/FreeBreakfastOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import { Button, Divider, Tag } from "antd";
import env from "../../config/env";
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle } from "@mui/material";

function SubTable(props) {

  const [openDialog, setopenDialog] = useState(false);

  const { userData } = props;
  const [open, setOpen] = React.useState(false);
  const convertHH_MM_SS = (value) => {
    const val = ` ${Math.floor(value / 3600)}h ${Math.floor((value % 3600) / 60)}m`;
    // ${Math.floor(value % 60)} Sec`;
    return val;
  };

  // const convertHH_MM_SS = (value) => {
  // if (!value || isNaN(value)) return "0h 0m";
  // const hours = Math.floor(value / 3600);
  // const minutes = Math.floor((value % 3600) / 60);
  // return `${hours}h ${minutes}m`;
  // };

  return (
    <React.Fragment>
      <>
        <TableRow>
          <TableCell align="left" style={{ width: "20%", padding: "5px 16px" }}>
            <Box display="flex" alignItems="center" gap={2} >
              {userData?.profile_pic ? (
                <img
                  style={{
                    height: "40px",
                    width: "40px",
                    borderRadius: "50%",
                    objectFit: "fill",
                  }}
                  src={`${env.backend_api_endpoint}/files/${userData?.profile_pic}`}
                  alt={`${userData?.profile_pic}`}
                />
              ) : (
                // <AccountCircleIcon
                //   style={{
                //     height: 45,
                //     width: 45,
                //     borderRadius: "50%"
                //   }}
                // />
                <Tag
                  style={{
                    borderRadius: "60px",
                    fontWeight: "bold",
                    border: 0,
                    height: "40px",
                    width: "40px",
                    fontSize: "15px",
                    backgroundColor: "#c8e4fc",
                    color: "navy",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {userData?.userName?.split(" ").map((word) => word.charAt(0).toUpperCase()).join("")}
                </Tag>
              )}

              <Typography sx={{ '&.MuiTypography-root': { fontSize: "14px !important" } }}>
                {userData.userName}
                {userData?.data[0]?.punch_in?.split(" ")[1].split(":")[0] >= 11 &&
                  userData?.data[0]?.punch_in?.split(" ")[1].split(":")[1] > 0 && (
                    <span className="late_in_tag">Late</span>
                  )}
              </Typography>
            </Box>
          </TableCell>

          <TableCell
            // align="center"
            style={{ width: "10%", padding: "12px 16px" }}
          >
            <div style={{
              display: "flex",
              flexDirection: "column",
              // justifySelf: "center",
              gap: 5
            }}>

              {userData?.data?.length !== 0 &&
                userData?.data[userData?.data?.length - 1].punch_out === null &&
                userData?.data[userData?.data?.length - 1].on_break == 0 && (
                  <div style={{ display: "flex", }}>
                    <Tag
                      style={{
                        backgroundColor: "#c8fcdb",
                        color: "green",
                        borderRadius: "20px",
                        fontWeight: "bold",
                        border: "1px solid #37d571ff",
                        width: "170px",
                        paddingLeft: 6
                      }}
                    >
                      Running
                    </Tag>
                  </div>
                )}
              {userData?.data?.length !== 0 &&
                userData?.data[userData?.data?.length - 1].punch_out !== null &&
                userData?.data[userData?.data?.length - 1].on_break !== 0 && (
                  <div style={{ display: "flex", }}>
                    <Tag
                      style={{
                        backgroundColor: "#ffd6d6",
                        color: "maroon",
                        borderRadius: "20px",
                        fontWeight: "bold",
                        border: "1px solid #f27e7eff",
                        width: "170px",
                        paddingLeft: 6
                      }}
                    >
                      Stopped
                    </Tag>
                  </div>
                )}
              {userData?.data?.length === 0 && (
                <div >
                  <Tag
                    style={{
                      backgroundColor: "#ffd6d6",
                      color: "maroon",
                      borderRadius: "20px",
                      fontWeight: "bold",
                      border: "1px solid #f27e7eff",
                      width: "170px",
                      paddingLeft: 6
                    }}
                  >
                    Not Started
                  </Tag>
                </div>
              )}
              {userData?.data?.length !== 0 &&
                userData?.data[userData?.data?.length - 1].on_break == 1 && (
                  <div >
                    <Tag
                      style={{
                        backgroundColor: "#fff3cd",
                        color: "#856404",
                        borderRadius: "20px",
                        fontWeight: "bold",
                        border: "1px solid #f2cb4aff",
                        width: "170px",
                        paddingLeft: 6
                      }}
                    >
                      In Break
                    </Tag>
                  </div>
                )}

              {(userData?.leaveData?.length == 0 ||
                userData?.leaveData[0]?.leave_status == "Cancel" ||
                userData?.leaveData[0]?.leave_status == "Rejected") && (
                  <div >
                    <Tag
                      style={{
                        backgroundColor: "#c8e4fc",
                        color: "navy",
                        borderRadius: "20px",
                        fontWeight: "bold",
                        border: "1px solid #5cacf3ff",
                        width: "170px",
                        paddingLeft: 6
                      }}
                    >
                      Available
                    </Tag>
                  </div>
                )}
              {userData?.leaveData?.length !== 0 &&
                userData?.leaveData[0]?.leave_duration === 3 &&
                userData?.leaveData[0]?.leave_status !== "Cancel" &&
                userData?.leaveData[0]?.leave_status !== "Rejected" && (
                  <div style={{ display: "flex", }}>
                    <Tag
                      style={{
                        backgroundColor: "#ffd6d6",
                        color: "maroon",
                        borderRadius: "20px",
                        fontWeight: "bold",
                        border: "1px solid #f27e7eff",
                        width: "170px",
                        paddingLeft: 6
                      }}
                    >
                      Second Half
                    </Tag>
                  </div>
                )}
              {userData?.leaveData?.length !== 0 &&
                userData?.leaveData[0]?.leave_duration === 2 &&
                userData?.leaveData[0]?.leave_status !== "Cancel" &&
                userData?.leaveData[0]?.leave_status !== "Rejected" && (
                  <div style={{ display: "flex", }}>
                    <Tag
                      style={{
                        backgroundColor: "#ffd6d6",
                        color: "maroon",
                        borderRadius: "20px",
                        fontWeight: "bold",
                        border: "1px solid #f27e7eff",
                        width: "170px",
                        paddingLeft: 6
                      }}
                    >
                      First Half
                    </Tag>
                  </div>
                )}
              {userData?.leaveData?.length !== 0 &&
                userData?.leaveData[0]?.leave_duration === 1 &&
                userData?.leaveData[0]?.leave_status !== "Cancel" &&
                userData?.leaveData[0]?.leave_status !== "Rejected" && (
                  <div style={{ display: "flex", }}>
                    <Tag
                      style={{
                        backgroundColor: "#ffd6d6",
                        color: "maroon",
                        borderRadius: "20px",
                        fontWeight: "bold",
                        border: "1px solid #f27e7eff",
                        width: "170px",
                        paddingLeft: 6
                      }}
                    >
                      Full Day
                    </Tag>
                  </div>
                )}

            </div>
          </TableCell>

          {/* <TableCell
            align="center"
            style={{ width: "10%", padding: "5px 16px" }}
          >
            <>
              {(userData?.leaveData?.length == 0 ||
                userData?.leaveData[0]?.leave_status == "Cancel" ||
                userData?.leaveData[0]?.leave_status == "Rejected") && (
                  <div style={{ display: "flex", }}>
                    <p
                      style={{
                        backgroundColor: "#20AD91",
                        color: "white",
                        borderRadius: "10px",
                        fontWeight: "bold",
                        width: "100px",
                      }}
                    >
                      Available
                    </p>
                  </div>
                )}
              {userData?.leaveData?.length !== 0 &&
                userData?.leaveData[0]?.leave_duration === 3 &&
                userData?.leaveData[0]?.leave_status !== "Cancel" &&
                userData?.leaveData[0]?.leave_status !== "Rejected" && (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <p
                      style={{
                        backgroundColor: "orange",
                        color: "white",
                        borderRadius: "10px",
                        fontWeight: "bold",
                        width: "100px",
                      }}
                    >
                      Second Half
                    </p>
                  </div>
                )}
              {userData?.leaveData?.length !== 0 &&
                userData?.leaveData[0]?.leave_duration === 2 &&
                userData?.leaveData[0]?.leave_status !== "Cancel" &&
                userData?.leaveData[0]?.leave_status !== "Rejected" && (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <p
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "10px",
                        fontWeight: "bold",
                        width: "100px",
                      }}
                    >
                      First Half
                    </p>
                  </div>
                )}
              {userData?.leaveData?.length !== 0 &&
                userData?.leaveData[0]?.leave_duration === 1 &&
                userData?.leaveData[0]?.leave_status !== "Cancel" &&
                userData?.leaveData[0]?.leave_status !== "Rejected" && (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <p
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "10px",
                        fontWeight: "bold",
                        width: "100px",
                      }}
                    >
                      Full Day
                    </p>
                  </div>
                )}
            </>
          </TableCell> */}

          <TableCell
            // align="center"
            style={{
              width: "20%",
              padding: "5px 16px",
              // justifyContent: "center",
            }}
          >
            {userData.data.length === 0 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  // justifySelf: "center",
                  gap: 4
                }}
              >
                <div className="availability_value_box" >
                  <WatchLaterOutlinedIcon sx={{ color: "green", fontSize: 18, marginRight: 0.5 }} />
                  <p> In: -</p>
                </div>
                <div className="availability_value_box">
                  <WatchLaterOutlinedIcon sx={{ color: "red", fontSize: 18, marginRight: 0.5 }} />
                  <p> Out: -</p>
                </div>
              </div>
            ) : (() => {
              const firstEntry = userData.data[0];

              const punchOutDate = new Date(firstEntry?.punch_out);
              const punchInDate = new Date(firstEntry?.punch_in);

              const punchOut = firstEntry?.punch_out
                ? `${String(punchOutDate.getHours()).padStart(2, "0")}:${String(
                  punchOutDate.getMinutes()
                ).padStart(2, "0")}`
                : "00:00";

              const punchIn = firstEntry?.punch_in
                ? `${String(punchInDate.getHours()).padStart(2, "0")}:${String(
                  punchInDate.getMinutes()
                ).padStart(2, "0")}`
                : "00:00";

              const punchOuttime = moment(punchOut, "HH:mm").format("hh:mm A");
              const punchIntime = moment(punchIn, "HH:mm").format("hh:mm A");
              return (
                <>
                  <div
                    // key={index}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      // flexDirection: "column",
                      // justifySelf: "center",
                      // gap: 4
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                      }}
                    >
                      <div className="availability_value_box">
                        <WatchLaterOutlinedIcon sx={{ color: "green", fontSize: 18, marginRight: 0.5 }} />
                        <p>In: {firstEntry?.punch_in ? punchIntime : "00:00"}</p>
                      </div>

                      <div className="availability_value_box">
                        <WatchLaterOutlinedIcon sx={{ color: "red", fontSize: 18, marginRight: 0.5 }} />
                        <p>Out: {firstEntry?.punch_out ? punchOuttime : "00:00"}</p>
                      </div>
                    </div>

                    {userData.data.length > 1 &&
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          margin: 10
                          // position: "relative",
                          // bottom: "30px",
                          // left: "150px"
                        }}
                      >
                        <Tag
                          style={{
                            borderRadius: "20px",
                            height: "25px",
                            width: "25px",
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            border: 0,
                            backgroundColor: "#244DA0",
                            color: "white",
                            cursor: "pointer",
                          }}
                          onClick={() => setopenDialog(true)}
                        >
                          {userData.data.length}
                        </Tag>

                        {/* <InfoOutlineIcon
                          style={{
                            fontSize: "larger",
                            cursor: "pointer"
                          }}
                          onClick={() => setopenDialog(true)}
                        />

                        <span style={{ fontSize: 14 }}>{userData.data.length}</span> */}
                      </div>
                    }
                  </div>

                </>
              );
            })
              ()}
          </TableCell>

          <TableCell
            // align="center"
            style={{ width: "20%", padding: "5px 16px" }}
          >
            <div className="availability_value_box ">
              <FreeBreakfastOutlinedIcon sx={{ color: "orange", fontSize: 20, marginRight: 0.5 }} />
              <p>{convertHH_MM_SS(userData?.totalBreakHours)}</p>
            </div>
          </TableCell>

          <TableCell
            // align="center"
            style={{
              width: "20%",
              padding: "5px 16px",
            }}
          >
            <div className="availability_value_box ">
              <BusinessCenterOutlinedIcon sx={{ color: "blue", fontSize: 20, marginRight: 0.5 }} />
              <p>{convertHH_MM_SS(userData?.totalWorkingHours)}</p>
            </div>
          </TableCell>

          {/* <TableCell style={{ width: "15%", padding: "5px 16px" }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
              style={{ fontSize: "13px", fontWeight: "bold" }}
            >
              {open ? (
                <>
                  View Less
                  <ArrowCircleUpIcon sx={{ marginLeft: "2px" }} />
                </>
              ) : (
                <>
                  View More <ArrowCircleDownIcon sx={{ marginLeft: "2px" }} />
                </>
              )}
            </IconButton>
          </TableCell> */}
        </TableRow>

        {/* <TableRow>
          <TableCell
            style={{
              padding: 0,
            }}
            colSpan={6}
          >
            <Collapse in={open} timeout="auto" unmountOnExit>
              {userData?.data?.length !== 0 ? (
                <Table
                  size="small"
                  aria-label="purchases"
                  className="table_box"
                >
                  <TableHead className="table_Header_color">
                    <TableRow className="table_row">
                      <TableCell className="font_bold">Date</TableCell>
                      <TableCell className="font_bold">Punch In</TableCell>
                      <TableCell className="font_bold">Punch Out</TableCell>
                      <TableCell className="font_bold">Break Hours</TableCell>
                      <TableCell className="font_bold">Working Hours</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {userData.data.map((val, index) => {
                      let punchOutDate = new Date(val?.punch_out);
                      let punchInDate = new Date(val?.punch_in);
                      const a = val?.punch_out
                        ? String(punchOutDate.getHours()).padStart(2, "0") +
                        ":" +
                        String(punchOutDate.getMinutes()).padStart(2, "0")
                        : "00:00";
                      const b = val?.punch_in
                        ? String(punchInDate.getHours()).padStart(2, "0") +
                        ":" +
                        String(punchInDate.getMinutes()).padStart(2, "0")
                        : "00:00";

                      const punchOuttime = moment(a, "HH:mm").format("hh:mm A");
                      const punchIntime = moment(b, "HH:mm").format("hh:mm A");
                      return (
                        <>
                          <TableRow key={index}>
                            <TableCell component="th" scope="row">
                              {val.date}
                            </TableCell>
                            <TableCell>
                              <div className="availability_value_box">
                                <AccessTimeIcon className="availability_timer_icon" />
                                <p> {val?.punch_in ? punchIntime : "00:00"}</p>
                              </div>
                            </TableCell>
                            <TableCell>
                              <div className="availability_value_box">
                                <AccessTimeIcon className="availability_timer_icon" />
                                <p>{val?.punch_out ? punchOuttime : "00:00"}</p>
                              </div>
                            </TableCell>
                            <TableCell>
                              <div className="availability_value_box">
                                <AccessTimeIcon className="availability_timer_icon" />
                                <p>
                                  {val?.break_hours == null
                                    ? "0 Hr 0 Min 0 Sec"
                                    : `${Math.floor(
                                      val?.break_hours / 3600
                                    )} Hr  ${Math.floor(
                                      (val?.break_hours % 3600) / 60
                                    )} Min ${Math.floor(
                                      val?.break_hours % 60
                                    )} Sec`}
                                </p>
                              </div>
                            </TableCell>
                            <TableCell>
                              <div className="availability_value_box">
                                <AccessTimeIcon className="availability_timer_icon" />
                                <p>
                                  {val?.working_hours == null
                                    ? "0 Hr 0 Min 0 Sec"
                                    : `${Math.floor(
                                      val?.working_hours / 3600
                                    )} Hr  ${Math.floor(
                                      (val?.working_hours % 3600) / 60
                                    )} Min ${Math.floor(
                                      val?.working_hours % 60
                                    )} Sec`}
                                </p>
                              </div>
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                  </TableBody>
                </Table>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                    height: "50px",
                  }}
                >
                  <p style={{ textAlign: "center" }}>No records found.</p>
                </div>
              )}
            </Collapse>
          </TableCell>
        </TableRow> */}
        <Dialog
          className="Leave_dialog_m"
          open={openDialog}
          onClose={() => setopenDialog(false)}
        >
          <DialogTitle id="dialog_title">
            <Box fontSize={18}>
              {userData.userName}
            </Box>
            <CloseIcon
              style={{ color: "grey", cursor: "pointer" }}
              onClick={() => setopenDialog(false)}
            />
          </DialogTitle>

          <Divider style={{ margin: "0px", height: "2px", backgroundColor: "#bbbec4ff" }} />

          <DialogContent>
            {userData.data.map((val, index) => {
              let punchOutDate = new Date(val?.punch_out);
              let punchInDate = new Date(val?.punch_in);
              const a = val?.punch_out
                ? String(punchOutDate.getHours()).padStart(2, "0") +
                ":" +
                String(punchOutDate.getMinutes()).padStart(2, "0")
                : "00:00";
              const b = val?.punch_in
                ? String(punchInDate.getHours()).padStart(2, "0") +
                ":" +
                String(punchInDate.getMinutes()).padStart(2, "0")
                : "00:00";

              const punchOuttime = moment(a, "HH:mm").format("hh:mm A");
              const punchIntime = moment(b, "HH:mm").format("hh:mm A");
              return (
                <div
                  className="Leave_dialog"
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    padding: 1.5,
                    marginBottom: 7,
                    // border: "1px solid #e0e0e0",
                    // borderRadius: 2,
                    // backgroundColor: "#fafafa"
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <WatchLaterOutlinedIcon sx={{ color: "green", fontSize: 18, }} />
                    <Typography variant="subtitle1">Punch In</Typography>
                    <Typography variant="body2">
                      {val?.punch_in ? punchIntime : "00:00"}
                      {/* {rowData.leave_status ? rowData.leave_status : "-"} */}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <WatchLaterOutlinedIcon sx={{ color: "red", fontSize: 18, }} />
                    <Typography variant="subtitle1">Punch Out</Typography>
                    <Typography variant="body2">
                      {val?.punch_out ? punchOuttime : "00:00"}
                      {/* {rowData.leave_status ? rowData.leave_status : "-"} */}
                    </Typography>
                  </Box>
                </div>
              )
            })}

            {/* <Box
              //   display="flex"
              //   justifyContent="center"
              //   alignItems="center"
              //   width="500px"
              //   gap={2}
              //   mt={1}
              // >
              //   {rowData.leave_status === "Pending" && (
              //   <>
              //     {/* Approve Button */}
            {/* <Button
              //       onClick={() => acceptPopup(rowData)}
              //       sx={{
              //         backgroundColor: "green",
              //         borderRadius: "6px",
              //         color: "white",
              //         textTransform: 'none',
              //         fontFamily: "MilliardMedium",
              //         '&:hover': {
              //           backgroundColor: "green",
              //         }
              //       }}
              //     >Approved</Button>

              //   </> */}
            {/* )} */}
            {/* </Box> */}

          </DialogContent>
        </Dialog>
      </>
    </React.Fragment >
  );
}

export default SubTable;
